import Index from './Index.vue';

export default {
  path: 'resinas',
  name: 'produto-resina',
  component: Index,
};
